// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/CSTEM/cstembanner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/CSTEM/cstem-mob-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cstem-top-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 28.2vw;
}

.cstem-banner-content .product-name-cstem h1,
.usp-sec-heading h2 {
  font-family: "NasalizationRg", sans-serif;
  color: #000;
}

.product-name-cstem {
  display: flex;
  align-items: center;
}

.product-name-cstem img {
  height: 70px;
  width: 150px;
}

.cstem-banner-content {
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-10%, 80%);
}

.usp-sec-heading {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  column-gap: 10px;
}

.usp-sec-heading h2 {
  margin-bottom: 0.8rem;
}

.usp-sec-heading img {
  height: 70px;
  width: 150px;
}

.usp-sec-heading-text {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}

.usp-sec-heading-text p {
  color: #6c6c6c;
  font-weight: 500;
  margin-bottom: -54px;
}

.usp-sec-banner img {
  height: auto;
  width: 100%;
}

.cstem-left {
  text-align: right;
}

.cstem-right {
  text-align: left;
}

.cstem-left p,
.cstem-right p {
  text-transform: uppercase;
  color: var(--dBlue);
  margin-bottom: 0px;
}

.cstem-right p {
  color: var(--dPink);
}

.cstem-maths-kit {
  background-color: #f5f6fb;
}

.usp-sec-banner,
.cstem-table-image {
  padding: 0 13%;
}

.about-cstem-kit p,
.about-thiking-process p,
.bricks-modals-img {
  color: #6c6c6c;
  font-weight: 500;
  padding: 0% 10%;
  margin-bottom: 30px;
  text-align: justify;
  font-size: 18px;
}

.cs-img-c img {
  height: 100px;
  width: auto;
}

.usp-images-wrapper {
  padding: 0 10%;
}

.cstem-usp-img::after {
  content: "";
  position: absolute;
  background-color: #76777c;
  width: 2px;
  height: 50px;
  left: 23%;
  top: 23%;
}

.cui-border-b::after {
  content: "";
  position: absolute;
  background-color: #76777c;
  width: 2px;
  height: 50px;
  left: 50%;
  top: 23%;
}

.cui-border-c::after {
  content: "";
  position: absolute;
  background-color: #76777c;
  width: 2px;
  height: 50px;
  left: 69%;
  top: 23%;
}

/* Learning spiral and learning steps  */
.leraning-spiral-and-steps-wrapper {
  padding: 2% 10% 1% 10%;
}

.five-strands {
  padding: 0 10%;
}

.five-strands ol {
  padding: 1rem;
}

.five-strands ol li {
  padding-bottom: 20px;
  font-weight: 500;
  text-align: justify;
}

@media (max-width: 1024px) {
  .cstem-banner-content .product-name-cstem h1 {
    margin-bottom: -5px;
  }

  .cstem-banner-content {
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-68%, 25%);
  }

  .usp-sec-heading {
    align-items: flex-end;
  }

  .cstem-usp-img::after {
    content: normal;
    content: initial;
  }

  .cui-border-b img {
    padding-top: 45px;
  }

  .about-thiking-process p {
    margin-bottom: 0px;
  }

  .leraning-spiral-and-steps-wrapper {
    padding-bottom: 50px;
  }
}

@media (max-width: 576px) {
  .cstem-top-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: 0 0;
    background-position: initial;
    height: 127.2vw;
  }

  .product-name-cstem h1 {
    margin-bottom: -8px;
  }

  .cstem-banner-content {
    transform: translate(-50%, 15%);
    width: 100%;
    left: 50%;
    padding: 0 10%;
  }

  .usp-sec-heading {
    justify-content: center;
    column-gap: normal;
    column-gap: initial;
  }

  .usp-sec-heading h2 {
    margin-bottom: 1rem;
  }

  .usp-sec-heading-text {
    align-items: flex-start;
    justify-content: center;
  }

  .usp-sec-heading-text p {
    margin-bottom: 0px;
    margin-top: -15px;
  }

  .usp-sec-banner,
  .cstem-table-image {
    padding: 0;
    padding: initial;
  }

  .cstem-usp-img::after,
  .cui-border-b::after,
  .cui-border-c::after {
    content: normal;
    content: initial;
  }

  .cui-border-a img {
    height: 100px;
    width: auto;
  }

  .cstem-learning-spiral,
  .learning-steps {
    padding-bottom: 20px;
  }

  .about-thiking-process p {
    margin-bottom: 0;
    margin-bottom: initial;
  }

  .five-strands {
    padding: 0%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/CSTEM/CSTEM.css"],"names":[],"mappings":"AAAA;EACE,yDAAwE;EACxE,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,yDAA6E;IAC7E,wBAA0B;IAA1B,4BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,WAAW;IACX,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,kBAAiB;IAAjB,mBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,UAAc;IAAd,gBAAc;EAChB;;EAEA;;;IAGE,eAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,gBAAoB;IAApB,sBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".cstem-top-banner {\n  background-image: url(\"../../../../public/images/CSTEM/cstembanner.png\");\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 28.2vw;\n}\n\n.cstem-banner-content .product-name-cstem h1,\n.usp-sec-heading h2 {\n  font-family: \"NasalizationRg\", sans-serif;\n  color: #000;\n}\n\n.product-name-cstem {\n  display: flex;\n  align-items: center;\n}\n\n.product-name-cstem img {\n  height: 70px;\n  width: 150px;\n}\n\n.cstem-banner-content {\n  position: absolute;\n  top: 50%;\n  left: 25%;\n  transform: translate(-10%, 80%);\n}\n\n.usp-sec-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  column-gap: 10px;\n}\n\n.usp-sec-heading h2 {\n  margin-bottom: 0.8rem;\n}\n\n.usp-sec-heading img {\n  height: 70px;\n  width: 150px;\n}\n\n.usp-sec-heading-text {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n.usp-sec-heading-text p {\n  color: #6c6c6c;\n  font-weight: 500;\n  margin-bottom: -54px;\n}\n\n.usp-sec-banner img {\n  height: auto;\n  width: 100%;\n}\n\n.cstem-left {\n  text-align: right;\n}\n\n.cstem-right {\n  text-align: left;\n}\n\n.cstem-left p,\n.cstem-right p {\n  text-transform: uppercase;\n  color: var(--dBlue);\n  margin-bottom: 0px;\n}\n\n.cstem-right p {\n  color: var(--dPink);\n}\n\n.cstem-maths-kit {\n  background-color: #f5f6fb;\n}\n\n.usp-sec-banner,\n.cstem-table-image {\n  padding: 0 13%;\n}\n\n.about-cstem-kit p,\n.about-thiking-process p,\n.bricks-modals-img {\n  color: #6c6c6c;\n  font-weight: 500;\n  padding: 0% 10%;\n  margin-bottom: 30px;\n  text-align: justify;\n  font-size: 18px;\n}\n\n.cs-img-c img {\n  height: 100px;\n  width: auto;\n}\n\n.usp-images-wrapper {\n  padding: 0 10%;\n}\n\n.cstem-usp-img::after {\n  content: \"\";\n  position: absolute;\n  background-color: #76777c;\n  width: 2px;\n  height: 50px;\n  left: 23%;\n  top: 23%;\n}\n\n.cui-border-b::after {\n  content: \"\";\n  position: absolute;\n  background-color: #76777c;\n  width: 2px;\n  height: 50px;\n  left: 50%;\n  top: 23%;\n}\n\n.cui-border-c::after {\n  content: \"\";\n  position: absolute;\n  background-color: #76777c;\n  width: 2px;\n  height: 50px;\n  left: 69%;\n  top: 23%;\n}\n\n/* Learning spiral and learning steps  */\n.leraning-spiral-and-steps-wrapper {\n  padding: 2% 10% 1% 10%;\n}\n\n.five-strands {\n  padding: 0 10%;\n}\n\n.five-strands ol {\n  padding: 1rem;\n}\n\n.five-strands ol li {\n  padding-bottom: 20px;\n  font-weight: 500;\n  text-align: justify;\n}\n\n@media (max-width: 1024px) {\n  .cstem-banner-content .product-name-cstem h1 {\n    margin-bottom: -5px;\n  }\n\n  .cstem-banner-content {\n    position: absolute;\n    top: 50%;\n    left: 40%;\n    transform: translate(-68%, 25%);\n  }\n\n  .usp-sec-heading {\n    align-items: flex-end;\n  }\n\n  .cstem-usp-img::after {\n    content: unset;\n  }\n\n  .cui-border-b img {\n    padding-top: 45px;\n  }\n\n  .about-thiking-process p {\n    margin-bottom: 0px;\n  }\n\n  .leraning-spiral-and-steps-wrapper {\n    padding-bottom: 50px;\n  }\n}\n\n@media (max-width: 576px) {\n  .cstem-top-banner {\n    background-image: url(\"../../../../public/images/CSTEM/cstem-mob-banner.png\");\n    background-position: unset;\n    height: 127.2vw;\n  }\n\n  .product-name-cstem h1 {\n    margin-bottom: -8px;\n  }\n\n  .cstem-banner-content {\n    transform: translate(-50%, 15%);\n    width: 100%;\n    left: 50%;\n    padding: 0 10%;\n  }\n\n  .usp-sec-heading {\n    justify-content: center;\n    column-gap: unset;\n  }\n\n  .usp-sec-heading h2 {\n    margin-bottom: 1rem;\n  }\n\n  .usp-sec-heading-text {\n    align-items: flex-start;\n    justify-content: center;\n  }\n\n  .usp-sec-heading-text p {\n    margin-bottom: 0px;\n    margin-top: -15px;\n  }\n\n  .usp-sec-banner,\n  .cstem-table-image {\n    padding: unset;\n  }\n\n  .cstem-usp-img::after,\n  .cui-border-b::after,\n  .cui-border-c::after {\n    content: unset;\n  }\n\n  .cui-border-a img {\n    height: 100px;\n    width: auto;\n  }\n\n  .cstem-learning-spiral,\n  .learning-steps {\n    padding-bottom: 20px;\n  }\n\n  .about-thiking-process p {\n    margin-bottom: unset;\n  }\n\n  .five-strands {\n    padding: 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
